import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetRunningTimer() {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/time/runningTimer`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetRunningTimers() {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/time/runningTimers`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetRunningTimerByUser(userId) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/time/by-user/${userId}/timer`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetTimers(parentType, parentId) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/time/${parentType}/${parentId}/timer`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetTimeRecordsByUser(userId, startDate, endDate) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/time/by-user/${userId}`,
        params: { startDate, endDate },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetTimeByUserTotal(userId, startDate, endDate) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/time/by-user/${userId}/total`,
        params: { startDate, endDate },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetTimeProfile(userId) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/time/by-user/${userId}/profile`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCreateTime(parentType, parentId, timeData) {
    return axios.request({
        method: "post",
        url: `${getApiUrl()}/time/${parentType}/${parentId}`,
        data: timeData,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateTime(timeId, timeData) {
    return axios.request({
        method: "put",
        url: `${getApiUrl()}/time/${timeId}`,
        data: timeData,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteTime(timeId) {
    return axios.request({
        method: "delete",
        url: `${getApiUrl()}/time/${timeId}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRestoreTime(timeId) {
    return axios.request({
        method: "put",
        url: `${getApiUrl()}/time/${timeId}/restore`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetClientsWithRecentActivity() {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/time/clients-with-recent-activity`,
        withCredentials: true,
        crossorigin: true,
    });
}